export default function TypeConditionalCheckbox({ value }) {
  if (Array.isArray(value)) {
    return (
      <div>
        <ul style={{ padding: "0px" }}>
          {value.map((val, idx) => (
            <li key={idx} >
              {val}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  return <div>{value} </div>
}
